import React from 'react'
import styles from './styles.module.css'

function SIC ({ record }) {
  return (
    <div className={styles.SICContainer}>
      <label className={styles.SICLabel}>SIC</label>
      {record?.sic ? (
        <span className={styles.SICValue}>{record?.sic}</span>
      ) : (
        <span className={styles.noSICValue}>N/A</span>
      )}
    </div>
  )
}

export default SIC
